import AccessTimeIcon from '@mui/icons-material/AccessTime'
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk'
import TrendingDownIcon from '@mui/icons-material/TrendingDown'
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty'

function LandingProblems () {
  return (
    <section className='lp-problem-section'>
      <div className='lp-section-content'>
        <h2 className='lp-section-title'>Kennen Sie diese Probleme?</h2>
        <div className='lp-problem-grid'>
          <div className='lp-problem-card'>
            <div className='lp-problem-icon'>
              <AccessTimeIcon sx={{ fontSize: 48 }} />
            </div>
            <h3>Zeitverschwendung</h3>
            <p>
              Techniker verbringen Stunden mit der Suche in unzähligen Manuals
              und Dokumenten.
            </p>
          </div>
          <div className='lp-problem-card'>
            <div className='lp-problem-icon'>
              <PhoneInTalkIcon sx={{ fontSize: 48 }} />
            </div>
            <h3>Ständige Rückfragen</h3>
            <p>
              10 Anrufe an Kollegen, bis das Problem endlich gelöst ist –
              ineffizient für alle.
            </p>
          </div>
          <div className='lp-problem-card'>
            <div className='lp-problem-icon'>
              <TrendingDownIcon sx={{ fontSize: 48 }} />
            </div>
            <h3>Wissensverlust</h3>
            <p>
              Wenn erfahrene Mitarbeiter gehen, geht wertvolles Fachwissen
              unwiederbringlich verloren.
            </p>
          </div>
          <div className='lp-problem-card'>
            <div className='lp-problem-icon'>
              <HourglassEmptyIcon sx={{ fontSize: 48 }} />
            </div>
            <h3>Lange Einarbeitung</h3>
            <p>
              Neue Techniker brauchen Monate, bis sie selbstständig arbeiten
              können.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default LandingProblems

